export default {"src":"/_next/static/media/user.bf927f74.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};